import { useTranslation } from 'react-i18next';

export const MessageDeleted = () => {
    const { t } = useTranslation();

    return <span className="italic">{t('Chat.Message.Deleted')}</span>;
};
